import Circle from './circle';
import Bar from './bar';
var Progress = {
    Circle: Circle,
    Bar: Bar,
};
export default Progress;
//# sourceMappingURL=index.js.map